import { useEffect } from "react"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { AssetViewColumnHeaderCell } from "routes/asset-register/plugins/regime-display/asset-view-table/asset-view-column-header-cell"

export function AssetRegisterColumnHeaderCell({ item: column, ...props }) {
    const { items, assetsLoaded, hideColumn } = useBoundContext()
    useEffect(syncHideColumn, [items, assetsLoaded, column, hideColumn])
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => () => hideColumn?.(column.field, false), [])

    return <AssetViewColumnHeaderCell item={column} {...props} />

    function syncHideColumn() {
        if (!assetsLoaded || !hideColumn) return
        const isEmpty =
            !column.required && !items?.some((item) => item[column.field] != null && item[column.field] !== "")
        hideColumn(column.field, isEmpty)
    }
}
